// eslint-disable-next-line no-unused-vars
/* global __webpack_public_path__:true */

// eslint-disable-next-line camelcase
__webpack_public_path__ = window.breadcrumbsV2Data.configuration.breadcrumbsV2ServiceConfiguration.assetsUrl;
